/* Polyfill explanation (PBruno):
 * Issue arising (for whatever reason) only on mobile. Explanation can be found here: http://bugs.jqueryui.com/ticket/8501
 * It basically states that jQuery removed jQuery.curCSS as an alias for jQuery.css (NOT to be confused with jQuery.fn.css).
 * jQuery UI 1.8.21 and below had references to this method, which made them incompatible with jQuery (base) 1.8 (which removed this method).
 * this is a simple polyfill to add it back, and stop the mobile site from breaking when the code aggregation is on.
 */
if (jQuery && !jQuery.curCSS) {
  jQuery.curCSS = jQuery.css;
}
